<template>
  <div class="p-4 bg-white dark:bg-gray-900 rounded-lg shadow">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-bold">Moth Control</h3>
      <button @click="autoMode = !autoMode" 
              class="px-3 py-1 text-sm rounded"
              :class="autoMode ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-700'">
        {{ autoMode ? 'Auto ON' : 'Auto OFF' }}
      </button>
    </div>

    <!-- Species -->
    <div class="mb-4">
      <h4 class="font-semibold mb-2">Active Species</h4>
      <div class="grid grid-cols-2 gap-2">
        <div v-for="species in species" :key="species.id" 
             class="p-2 border rounded text-sm">
          <div class="font-medium">{{ species.name }}</div>
          <div class="text-gray-600">{{ species.count }} found</div>
        </div>
      </div>
    </div>

    <!-- Traps -->
    <div class="mb-4">
      <h4 class="font-semibold mb-2">Traps</h4>
      <div class="grid grid-cols-3 gap-2">
        <div v-for="trap in traps" :key="trap.id" 
             class="p-2 border rounded text-center text-sm">
          <div>{{ trap.location }}</div>
          <div class="text-gray-600">{{ trap.count }} moths</div>
          <div class="text-xs">{{ trap.battery }}% battery</div>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="grid grid-cols-2 gap-2">
      <button @click="deployPheromones" 
              class="px-3 py-2 bg-blue-500 text-white rounded text-sm">
        Deploy Pheromones
      </button>
      <button @click="activateLights" 
              class="px-3 py-2 bg-purple-500 text-white rounded text-sm">
        Activate Lights
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const autoMode = ref(false)

const species = ref([
  { id: 1, name: 'Fall Armyworm', count: 12 },
  { id: 2, name: 'Corn Earworm', count: 8 },
  { id: 3, name: 'Diamondback', count: 25 },
  { id: 4, name: 'Cabbage Looper', count: 5 }
])

const traps = ref([
  { id: 'T1', location: 'North', count: 8, battery: 87 },
  { id: 'T2', location: 'East', count: 12, battery: 92 },
  { id: 'T3', location: 'South', count: 3, battery: 45 }
])

const deployPheromones = () => {
  console.log('Deploying pheromones')
}

const activateLights = () => {
  console.log('Activating lights')
}
</script>
